import React, {
  useCallback,
  useContext,
  useRef,
  useState,
  forwardRef,
} from "react";
import AppContext from "../../../AppContext.jsx";
import { langComponent } from "../../../constants/index.jsx";

import { ReactComponent as FileUploaderPlaceholderSvg } from "../../../assets/icons/fileuploader-placeholder.svg";
import PropTypes from "prop-types";
import "../../../styles/imageUploadBox.scss";

const ImageUploadBox = forwardRef(
  ({ name, onChange, placeHolderSvg, multiple, height }, ref) => {
    const { getLang } = useContext(AppContext);
    const Translation = getLang(langComponent.project);
    const TranslationCommon = getLang(langComponent.common);
    const [dragActive, setDragActive] = useState(false);
    // const fileInputRef = useRef();
    const ImageUploadBoxRef = useRef();
    const inputFileRef = useRef(null);

    const handleFiles = (files) => {
      if (files.length === 0) return;

      onChange(files);
      // * Clear input value
      inputFileRef.current.value = "";
    };

    const handleDragDropEvents = (e) => {
      e.preventDefault();
      e.stopPropagation();
      // console.log(e.type);
      if ((e.type === "dragenter" || e.type === "dragover") && !dragActive) {
        setDragActive(true);
      }

      if ((e.type === "dragleave" || e.type === "drop") && dragActive) {
        setDragActive(false);
      }

      if (e.type === "drop") {
        handleFiles(e.dataTransfer.files);
      }
    };
    const handleLabelClick = () => {
      ref.current.click();
    };

    return (
      <div className="image-upload" ref={ImageUploadBoxRef}>
        <div
          className={`image-upload-file-uploader ${
            dragActive ? "image-upload-file-uploader--highlight" : ""
          }`}
          onDragEnter={handleDragDropEvents}
          onDragOver={handleDragDropEvents}
          onDragLeave={handleDragDropEvents}
          onDrop={handleDragDropEvents}
        >
          {placeHolderSvg ? placeHolderSvg : <FileUploaderPlaceholderSvg />}
          <p className="image-upload-file-uploader__info">
            {Translation("Drop your images here or")}{" "}
            <label
              className="image-upload-file-uploader__input-trigger"
              // onClick={handleLabelClick}
              htmlFor={name}
            >
              {Translation("browse")}
            </label>
            <br />
            {Translation("Supports: JPG and PNG")}
          </p>
          <input
            id={name}
            // id="image-upload-file-uploader__input"
            style={{ display: "none" }}
            type="file"
            accept="image/*"
            ref={inputFileRef}
            multiple={multiple}
            onChange={(e) => handleFiles(e.target.files)}
          />
        </div>
      </div>
    );
  }
);

ImageUploadBox.propTypes = {
  onChange: PropTypes.func,
  placeHolderSvg: PropTypes.element,
  multiple: PropTypes.bool,
  ref: PropTypes.any,
};

ImageUploadBox.defaultProps = {
  onChange: () => {},
  multiple: false,
};
export default ImageUploadBox;
